import PromptList from './PromptList';
import SettingEditEmbedded from '../settings/SettingEditEmbedded';

const prompts = {
  list: PromptList,
  edit: SettingEditEmbedded,
};

export default prompts;
export { prompts };
